module.exports = __webpack_public_path__ + "media/images/redesign-images/cm/leah-poster-38e8f71f08c54a36395163654401944c.jpg";